export default __webpack_public_path__ + "static/3-538e7932c28dba76c04d3315709b6837.jpeg";